import { Component, OnInit } from '@angular/core';
import { NgbDateAdapter, NgbModal, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { TravelService } from 'src/app/services/travel.service';
import { Travel } from 'src/app/models/travel';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { PaysheetService } from 'src/app/services/paysheet.service';
import { ToastrManager } from 'ng6-toastr-notifications';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-paysheet-expenses',
  templateUrl: './paysheet-expenses.component.html',
  styleUrls: ['./paysheet-expenses.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class PaysheetExpensesComponent implements OnInit {

  date1:Date = new Date(); //Inicio
  date2:Date = new Date(); //Fin
  travels:any[] = [];
  travelSel:any;
  loading:boolean = false;
  d:Date = new Date();
  expand:boolean = false;

  updown:number = 1;
  sorted:string = '';
  status:string = '';
  
  filterFlag:boolean = false;
  travelsOrig: any[] = [];
  //
  flagUpdateTravel: boolean = null;

  constructor(private travelServ:TravelService, private modal:NgbModal, private utl:UtilitiesService, private payServ:PaysheetService, private toastr: ToastrManager) {
    this.date1.setDate(this.date1.getDate() - 6);
   }

  ngOnInit() { }

  search () {
    if(this.filterFlag){
      var d = (document.getElementById("id-travel")) as HTMLSelectElement;
      d.value = '';
    }
    
    if(this.date1 <= this.date2)
    {
      this.loading = true;
      this.travelServ.getTravelsByDates(this.date1, this.date2, {status: 'Cerrado'}).then(travels => {
        this.travels = this.mapTravels(travels);
        this.travelsOrig = this.travels;
        this.filterFlag = (this.travels.length > 0) ? true : false;
        if(this.flagUpdateTravel == null || !this.flagUpdateTravel){
          this.loading = false;
          this.flagUpdateTravel = null;
        }
      }).catch( error => {
        this.loading = false;
        this.flagUpdateTravel = null;
        this.toastr.errorToastr('Ocurrió un error al obtener los viajes, recargar la página nuevamente. Si persiste el error contacte con soporte de la plataforma.', '', { enableHTML: true });
      });
    }else{
      this.toastr.errorToastr('Las fechas de filtrado no son válidas. Por favor, ingrese fechas válidas.', '', { enableHTML: true });
    }    
  }

  mapTravels(travels:Travel[]) {
    let trs2 = [];

    for(let i = 0; i < travels.length; i++) {
      let travel = travels[i]; 

      let sourceCustomer = travel.lines[0].source_customer;
      let sourceCustomerId = travel.lines[0].source_customer_id;

      for(let j = 0; j < travel.lines.length; j++) {
        if (!travel.contracted && travel.lines[j].presentation_name != 'Vacio') {                
                                                            
          let targetCustomer = travel.lines[j].source_customer_id == sourceCustomerId ? travel.lines[j].target_customer : travel.lines[j].source_customer; 

          let targetCustomerAddress = travel.lines[j].source_customer_id == sourceCustomerId ? travel.lines[j].target_customer_address : travel.lines[j].source_customer_address;
                              
          if (travel.lines[j].source_customer_id != sourceCustomerId && travel.lines[j].target_customer_id != sourceCustomerId) {
              targetCustomer = travel.lines[j].target_customer; 
              targetCustomerAddress = travel.lines[j].target_customer_address; 
          }

          let register = {
            id: travel.id,
            set_id: travel.set_id,
            order_id: travel.lines[j].order_id,
            delivery_date: travel.delivery_date,
            operator_name: travel.operator.name + ' ' + travel.operator.last_name,
            helper_1_name: travel.helper_1 ? travel.helper_1.name + ' ' + travel.helper_1.last_name : '',
            helper_2_name: travel.helper_2 ? travel.helper_2.name + ' ' + travel.helper_2.last_name : '',
            operator_cost: travel.operator_cost,
            helper_1_cost: travel.helper_1_cost,
            helper_2_cost: travel.helper_2_cost,
            paysheet_base: travel.paysheet_base,
            paysheet_type: travel.paysheet_type,
            paysheet_date: travel.paysheet_date,
            customer: targetCustomer, 
            product: travel.lines[j].product_name,
            ton: travel.lines[j].ton,
            ton_real: travel.lines[j].ton_real,
            presentation: travel.lines[j].presentation_name,
            address: targetCustomerAddress, 
            source_customer: sourceCustomer, 
            status: travel.status,
            num_lines: travel.lines[j].num_lines,
            closed: travel.paysheet_base ? false : false, //cambiar..........
            paysheet_in_cash_operator: travel.paysheet_in_cash_operator,
            paysheet_in_cash_helper_1: travel.paysheet_in_cash_helper_1,
            paysheet_in_cash_helper_2: travel.paysheet_in_cash_helper_2,
            user_calculates_paysheet_expenses_id: travel.user_calculates_paysheet_expenses_id,
            userCalculatesPaysheetExpenses: (travel.userCalculatesPaysheetExpenses) ? travel.userCalculatesPaysheetExpenses : null,
            datetime_calculates_paysheet_expenses: travel.datetime_calculates_paysheet_expenses
          };
          
          if (travel.lines[j].source_customer != sourceCustomer && travel.lines[j].target_customer != sourceCustomer) {
            register.customer = travel.lines[j].target_customer;
          }

          trs2.push(register);
        }
      }
    }
    this.flagUpdateTravel = false;

    return trs2;
  }

  select(unityModal, travel:Travel) {
    this.travelSel = travel;
    this.modal.open(unityModal, { size: 'lg' });
  }

  openModal(travel:Travel, paysheetModal) {
    if (travel) {
      this.travelSel = travel;
      this.d = this.utl.getDateFromString(this.travelSel.paysheet_date);
    }
    this.modal.open(paysheetModal, { size: 'lg' });
  }

  save() {
    let info = {
      operator_cost: this.travelSel.operator_cost,
      helper_1_cost: this.travelSel.helper_1_cost,
      helper_2_cost: this.travelSel.helper_2_cost,
      date: this.d,
      type: this.travelSel.paysheet_type,
      base: this.travelSel.paysheet_base,
      paysheet_in_cash_operator: this.travelSel.paysheet_in_cash_operator,
      paysheet_in_cash_helper_1: this.travelSel.paysheet_in_cash_helper_1,
      paysheet_in_cash_helper_2: this.travelSel.paysheet_in_cash_helper_2,
    };

    this.loading = true;
    this.travelServ.postPaysheet(this.travelSel, info).then(resp => {
      this.flagUpdateTravel = true;
      this.search();
      //this.loading = false; //Se establece en falso hasta que el metodo search() acaba de actualizar la informacion de los viajes cuando se calcula un viaje, para que muestre quien, cuando y a que hora calculo el viaje
      this.toastr.successToastr("El viaje " + this.travelSel.id + " fue actualizado correctamente. Por favor espera un momento mientras se actualiza la información.", '', {enableHTML: true});
    }).catch(e => {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(e), '', { enableHTML: true });
    });
  }

  calcPaysheet() {
    let toUpdate = this.travels.length;
    let totalUpdated = 0;

    if (toUpdate) {
      this.loading = true;
      this.travels.forEach(travel => {
        this.payServ.calculatePaysheet(travel, this.d).then(res => {
          if (res.type) {
            travel.operator_cost = res.operator;
            travel.helper_1_cost = travel.helper_1_name ? res.helper : 0;
            travel.helper_2_cost = travel.helper_2_name ? res.helper : 0;
            travel.paysheet_type = res.type;
            travel.paysheet_base = res.base;
            travel.paysheet_date = this.d.toString();
            //travel.closed = true;
    
            totalUpdated += 1;
    
            if (totalUpdated == toUpdate) {
              this.loading = false;
            }
          }
        });
      });
    }
  }

  calcPaysheetLine(travel) {
    this.loading = true;
    this.payServ.calculatePaysheet(travel.id, this.d).then(res => {
      if (res.type) {
        travel.operator_cost = res.operator;
        travel.helper_1_cost = travel.helper_1_name ? res.helper : 0;
        travel.helper_2_cost = travel.helper_2_name ? res.helper : 0;
        travel.paysheet_type = res.type;
        travel.paysheet_base = res.base;
        travel.paysheet_date = this.d.toString();
        this.flagUpdateTravel = true;
        this.search();
        this.toastr.successToastr("El viaje " + travel.id + " fue actualizado correctamente. Por favor espera un momento mientras se actualiza la información.", '', {enableHTML: true});
        //travel.closed = true;
      }else{
        this.loading = false;
      }
      //this.loading = false;
    }).catch(error => {
      this.loading = false;
      this.toastr.errorToastr('', '', {enableHTML: true});
    });
  }

  sort(param) {
    this.travels = this.travels.sort(this.utl.dynamicSort((this.updown == 1 ? '' : '-') + param));
    this.updown = this.updown*-1;
    this.sorted = param;
  }

  advancedFilter(event){
    let travel_id = String(event.target.value).trim();
    if(travel_id){
      this.travels = this.travelsOrig;
      this.filterFlag = true;
      this.travels = _.filter(this.travels, function(o){
        return _.startsWith(o.id, travel_id);
      });
    }else{
      this.travels = this.travelsOrig;
    }
  }

  download(reportType = 'excel'){
    if(reportType == 'excel'){
      window.open(environment.baseUrl + '/' + reportType + '/travels/paysheet-expenses?date1=' + this.date1.toString() + '&date2=' + this.date2.toString(), '_blank');
    }
  }
}
